import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  Alert,
  Button,
  Form,
  Grid,
  Input,
  theme,
  Typography,
  InputNumber,
} from "antd";

import whitelabelConfig from "@whitelabel-config";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import i18n from "i18next";
import { useAuthProvider } from "../../../pages/Auth/hooks/useAuthProvider";
import { useAuthSrv } from "pages/Auth/hooks/useAuthSrv";
import BgImage from "assets/img/bg-image.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import piiMeta from "../meta_config.json";
import DateOfBirth from "./DateOfBirth";
import AppLogo from "./../../../components/AppLogo/AppLogo";
import PendingSurveyList from "./../../../components/PendingSurveyList/PendingSurveyList";
import BrandColors from "@brand-colors";
import { portalActions } from "store/portal-slice";
import { clearLocalStore } from "helpers/localStoreSrv";
import ReactGA from "react-ga";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import PendingSurveyListThankYou from "components/PendingSurveyList/PendingSurveyListThankYou";
import { usePageTitle } from "helpers/usePageTitle";
import { useSessionDetailLog } from "helpers/useSessionDetailLog";
const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Text, Title } = Typography;
const AuthPage = (props: any) => {
  const navigate = useNavigate();
  const portalAuthSession = useSelector(
    (state: any) => state.portal.authSession
  );

  const portalMicrositeSession = useSelector(
    (state: any) => state.portal.micrositeSession
  );
  console.log("portalAuthSession", portalMicrositeSession);
  const uiState = useSelector((state: any) => state.portal.uiState);
  const { state } = useLocation();
  const { authStep } = state || {};
  const { token } = useToken();
  const screens = useBreakpoint();
  const { verifyPII } = useAuthSrv();
  const { logSessionDetail } = useSessionDetailLog();
  const [failedAttempt, setFailedAttempt] = useState(0);
  const [dob, setDOB] = useState([]);
  const [isDobValid, setIsDobValid] = useState(true);
  const [isDobValidationMsg, setIsDobValidationMsg] = useState("");
  const [zip, setZip] = useState("");
  const [isZipValid, setIsZipValid] = useState(true);
  const [isZipValidationMsg, setIsZipValidationMsg] = useState("");
  const [ssn, setSsn] = useState("");
  const [isSsnValid, setIsSsnValid] = useState(true);
  const [isSsnValidationMsg, setIsSsnValidationMsg] = useState("");
  const [medicaid, setMedicaid] = useState("");
  const [isMedicaidValid, setIsMedicaidValid] = useState(true);
  const [isMedicaidValidationMsg, setIsMedicaidValidationMsg] = useState("");
  const [memberID, setMemberID] = useState();
  const [surveyUniqueReference, setSurveyUniqueReference] = useState();
  const [surveyDob, setSurveyDob] = useState(true);
  const [surveyDobUser, setSurveyDobUser] = useState("");
  const [isHover, setIsHover] = useState(false);
  const [isRightAlign, setIsRightAlign] = useState(false);
  const dispatch = useDispatch();
  const surveyLanguage = useSelector(
    (state: any) => state.portal.uiState.SurveyLanguage
  );
  const [selectedSurvey, setSelectedSurvey] = useState(null);
const dobErrorRef = useRef<HTMLDivElement>(null);
  // useEffect(() => {
  //   const storedSurvey = sessionStorage.getItem("selectedSurveyData");
  //    console.log("storedSurvey", storedSurvey);
  //   if (storedSurvey) {
  //     setSelectedSurvey(JSON.parse(storedSurvey));
  //     handleChangeSurvey(storedSurvey);
  //   }
  // }, []);
  useEffect(() => {
    const storedSurvey = sessionStorage.getItem("selectedSurveyData");
    console.log("storedSurvey", storedSurvey);

    if (storedSurvey) {
      const parsedSurvey = JSON.parse(storedSurvey); // Convert string to object
      setSelectedSurvey(parsedSurvey);
      handleChangeSurvey(parsedSurvey); // Pass the parsed object instead of a string
    }
  }, []);

  const filteredSurveys = selectedSurvey
    ? portalMicrositeSession.pendingSurveys.filter(
      (survey) => survey.Urn === selectedSurvey.Urn
    )
    : [];
  console.log("filteredSurveys", filteredSurveys);
  useEffect(() => {
    console.log("uiState.Language", uiState.Language);
    i18n.changeLanguage(uiState.Language);
    clearLocalStore();
  }, []);
  useEffect(() => {
    try {
      if (
        whitelabelConfig.uiSettings.rightAlignedLanguage.includes(
          surveyLanguage
        ) === true
      ) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e);
      handleErrorNavigation(e, navigate, t);
    }
  }, [isRightAlign]);

  useEffect(() => {
    dispatch(portalActions.updateAuthWizard({}));
    if (
      portalMicrositeSession &&
      portalMicrositeSession.pendingSurveys &&
      portalMicrositeSession?.pendingSurveys.length > 0
    ) {
      setSurveyDob(false);
    }
    if (portalMicrositeSession.landingUrlSnapshot.split("/")[1] == "av" || portalMicrositeSession.landingUrlSnapshot.split("/")[1] == "ar") {
      setSurveyDob(true);
    }
  }, portalMicrositeSession);
  const hasActiveMember = portalMicrositeSession?.pendingSurveys?.some(
    (member: { ActivityStatus: number }) => member.ActivityStatus === 120000001
  );
  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };
  const handleChangeSurvey = (surveyMeta: any) => {
    console.log("surveyMeta", surveyMeta);
    if (surveyMeta.Urn) {
      setMemberID(surveyMeta.MemberID);
      setSurveyUniqueReference(
        surveyMeta.Urn ? surveyMeta.Urn : portalMicrositeSession.urlRef
      );
      setSurveyDobUser(hashText(surveyMeta.MemberName));
      setSurveyDob(true);
      setDOB([]);
    }
  };
  const handleDateChange = (date: any, index: number) => {
    setDOB((prevDate) => {
      const updateDates: any = [...prevDate];
      updateDates[index] = date;
      return updateDates;
    });
  };
  const { updateAuthSession, updateAuthWizard } = useAuthProvider();
  const styles = {
    container: {
      margin: "0 auto",
      width: "450px",
      textAlign: "center",
      backgroundColor: token.colorBgContainer,
      zIndex: 100,
    },
    footer: {
      marginTop: token.marginLG,
      textAlign: "center",
      width: "100%",
    },
    forgotPassword: {
      float: "right",
    },
    header: {
      maxWidth: "85%",
      padding: "20px 0",
      margin: " 0 auto",
      fontWeight: "600",
      textAlign: isRightAlign ? "right" : "",
    },
    mainheader: {
      height: "80px",
      padding:
        whitelabelConfig.uiSettings.logoHeightFull === true ? "0 0" : "15px 0",
      backgroundColor: BrandColors.HEADER_BG,
    },
    subheader: {
      maxWidth: "100%",
    },
    subheaderinner: {
      maxWidth: "84%",
      padding: "0px 0 0px 0",
      margin: "0 auto",
      fontWeight: "600",
      textAlign: isRightAlign ? "right" : "",
    },
    section: {
      alignItems: "center",
      backgroundSize: "cover",
      display: "flex",
      padding: screens.md ? `${token.sizeXXL}px 0px` : "0px",
      height: "100vh",
    },
    text: {
      color: "#333",
      fontSize: "12px",
      lineHeight: "21px",
      display: "block",
      marginBottom: "10px",
      fontWeight: "600",
    },
    text_new: {
      color: "#333",
      fontSize: "12px",
      lineHeight: "21px",
      display: "block",
      marginBottom: "0px",
      fontWeight: "600",
    },
    texttitle: {
      color: "#333333",
      fontWeight: "bolder",
      fontSize: "14px",
      lineHeight: "1.5",
      marginTop: "0",
      marginBottom: "20",
    },
    headercontainer: {
      maxWidth: "85%",
      margin: " 0 auto",
      marginBottom: "15px",
      fontWeight: "600",
      textAlign: isRightAlign ? "right" : "",
    },
    title: {
      fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
    },
    bodycontainer: {
      maxWidth: "85%",
      margin: "0 auto",
      paddingBottom: "40px",
    },
    button: {
      backgroundColor: isHover ? token.colorBgContainer : BrandColors.BUTTON_BG,
      borderColor: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      color: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      height: "42px",
      borderRadius: "50px",
      textTransform: "uppercase",
      fontWeight: "500",
    },
    containwrapper: {
      padding: "0 15px",
      display: "flex",
      width: "100%",
    },
    formcontrolblock: {
      maxWidth: "84%",
      padding: "0px 0 15px 0",
    },
    formlabel: {
      color: "#333",
      fontSize: "12px",
      lineHeight: "21px",
      display: "block",
    },
  };
  const validatePiiForm = () => {
    let validStatus = true;
    if (authStep.extras?.authTypes?.includes("ZIP")) {
      validStatus = validateZipField(zip);
    }
    if (authStep.extras?.authTypes?.includes("DOB")) {
      validStatus = validateDobField(dob);
    }

    if (authStep.extras?.authTypes?.includes("SSN_MEDICAID")) {
      let ssnStat = validateSsnField(ssn);
      let medicaidStat = validateMedicaidField(medicaid);
      validStatus = ssnStat || medicaidStat;
    }
    return validStatus;
  };
  const validateDobField = (dobVal: any) => {
    if (!dobVal) {
      setIsDobValid(false);
      setIsDobValidationMsg(t("AUTHPII.ENTERDOBERR"));
      return false;
    } else if (
      (dobVal && dobVal.length < 3) ||
      dobVal.includes(undefined) ||
      dobVal.includes(null)
    ) {
      setIsDobValid(false);
      setIsDobValidationMsg(t("AUTHPII.ENTERVALIDDOBERR"));
       requestAnimationFrame(() => dobErrorRef.current?.focus());
      return false;
    } else {
      setIsDobValid(true);
      setIsDobValidationMsg("");
      return true;
    }
  };
  const validateZipField = (zipVal: any) => {
    if (!zipVal) {
      setIsZipValid(false);
      setIsZipValidationMsg("Enter Zipcode");
      return false;
    } else if (zipVal && zipVal.toString().length > 6) {
      setIsZipValid(false);
      setIsZipValidationMsg("Enter valid Zipcode");
      return false;
    } else {
      setIsZipValid(true);
      setIsZipValidationMsg("");
      return true;
    }
  };
  const validateMedicaidField = (medicaidVal: any) => {
    if (!medicaidVal) {
      setIsMedicaidValid(false);
      setIsMedicaidValidationMsg("Enter Medicaid ");
      return false;
    } else if (medicaidVal && medicaidVal.toString().length < 4) {
      setIsMedicaidValid(false);
      setIsMedicaidValidationMsg("Enter valid Medicaid");
      return false;
    } else {
      setIsMedicaidValid(true);
      setIsMedicaidValidationMsg("");
      return true;
    }
  };
  const validateSsnField = (ssnVal: any) => {
    if (!ssnVal) {
      setIsSsnValid(false);
      setIsSsnValidationMsg(t("AUTHPII.ENTERSSN"));
      return false;
    } else if (ssnVal && ssnVal.toString().length < 4) {
      setIsSsnValid(false);
      setIsSsnValidationMsg(t("AUTHPII.ENTERVALIDSSN"));
      return false;
    } else {
      setIsSsnValid(true);
      setIsSsnValidationMsg("");
      return true;
    }
  };
  const handleFinish = (values: any) => {
    let validationStat = validatePiiForm();
    if (!validationStat) return;
    const date = moment(dob, "MMDDYYYY");
    let piiDatas: any = {};
    if (!authStep.extras || authStep.extras?.authTypes?.includes("DOB")) {
      piiDatas = {
        DateOfBirth: date.format("YYYYMMDD"),
        MemberID: memberID ? memberID : null,
        SurveyUniqueReference: surveyUniqueReference
          ? surveyUniqueReference
          : null,
      };
    }
    if (authStep.extras && authStep.extras?.authTypes?.includes("ZIP")) {
      piiDatas["PostalCode"] = zip;
      piiDatas["AdditionalValidation"] = piiMeta.PII_AUTH_TYPE["ZIP"];
    }
    if (
      authStep.extras &&
      authStep.extras?.authTypes?.includes("SSN_MEDICAID")
    ) {
      piiDatas["SSN"] = ssn;
      piiDatas["Medicaid"] = medicaid;
      piiDatas["AdditionalValidation"] = piiMeta.PII_AUTH_TYPE["SSN_MEDICAID"];
    }
    verifyPII(piiDatas)
      ?.then((res: any) => {
        if (res.data.Authenticated === "true") {
          ReactGA.event({
            category: "Verify Details Button Click",
            action: "Success SecondLevel Auth",
            label: "Auth PII Page",
          });
          const authSession = {
            auth_progress: "PROGRESS",
            access_token: res.data.Access_Token,
            user_name: res.data.MemberName || res.data.PatientName,
          };
          updateAuthSession(authSession);
          if (
            whitelabelConfig.uiSettings.isFamilySurveyEnabled &&
            !!surveyUniqueReference
          ) {
            const sessionPayload = {
              urlRef: surveyUniqueReference,
            };
            dispatch(portalActions.updateMicrositeSession(sessionPayload));
          }
          updateAuthWizard(authStep.onSuccess);
        }
      })
      .catch((e) => {
        ReactGA.event({
          category: "Verify Details Button Click",
          action: "Failed SecondLevel Auth",
          label: "Auth PII Page",
        });
        if (e.status === 401) {
          setFailedAttempt((preValue) => {
            let newVal = preValue + 1;
            if (newVal === piiMeta.maxAttempts) {
              const authSession = {
                is_authenticated: false,
                auth_progress: "FAILED",
                access_token: "",
                user_name: "",
              };
              updateAuthSession(authSession);
            }

            return newVal;
          });
        }
      });
  };
  const { t } = useTranslation();
  const hashText = (text: string) => {
    if (text?.length < 5) return text;

    let shown = text?.slice(0, 5);
    let masked = "*".repeat(text?.length - 5);
    return shown + masked;
  };
  const validateMsg = () => {
    const maxAttempts = piiMeta.maxAttempts;
    const remainingAttempts = maxAttempts - failedAttempt;
    let errorMessage = "";
    if (failedAttempt < maxAttempts) {
      errorMessage = `${t(
        "AUTHPII.NUMBEROFATTEMPTSSTART"
      )} ${remainingAttempts} ${t("AUTHPII.NUMBEROFATTEMPTSEND")}`;
    } else {
      const navParams = {
        state: {
          errorCode: "",
          errorTitle: t("AUTHPII.MAXATTEMPTS"),
          errorDescription: " ",
        },
      };
      navigate("/unauthorised", navParams);
    }

    return errorMessage;
  };
  useEffect(() => {
    logSessionDetail("DobViewed");
    ReactGA.event({
      category: "SecondLevel Auth loaded",
      action: "Success OTP step",
      label: "Auth PII Page",
    });
  }, []);
  usePageTitle("AUTHPII.PAGE_TITLE", `Auth Pii Login - ${process.env.REACT_APP_PRODUCT}`);
  console.log("uiState.Language", uiState.Language);
  console.log("uiState.SurveyLanguage", uiState.SurveyLanguage);
  const hasDOBSurvey =
    portalMicrositeSession?.pendingSurveys &&
    Array.isArray(portalMicrositeSession.pendingSurveys) &&
    portalMicrositeSession.pendingSurveys.some(
      (survey) => survey.ActivityStatus === 120000000
    );

  console.log("selectedSurvey", selectedSurvey);
  return (
    <section style={styles.section}>
      <img
        src={BgImage}
        alt=""
        style={{
          objectFit: "cover",
          position: "absolute",
          maxWidth: "100%",
          height: "100vh",
          zIndex: 0,
          width: "100%",
        }}
      />
      <div style={styles.containwrapper}>
        <div style={styles.container}>
          <div style={styles.mainheader} className="logo-header">
            <AppLogo />
          </div>
          <div style={styles.header}>
            {(whitelabelConfig.uiSettings.isFamilySurveyEnabled ||
              !whitelabelConfig.uiSettings.isFamilySurveyEnabled) &&
              portalMicrositeSession.pendingSurveys &&
              portalMicrositeSession?.pendingSurveys.length > 1 ? (
              <></>
            ) : (
              <Title style={styles.texttitle} id="authpii-title" tabIndex={0} role="article">
                {t("AUTHPII.TITLE")}

                {portalAuthSession.user_name === "" ? (
                  <div>
                    {portalMicrositeSession?.pendingSurveys?.length > 0
                      ? hashText(portalMicrositeSession.pendingSurveys[0].MemberName)
                      : null}
                  </div>
                ) : (
                  <div>{hashText(portalAuthSession.user_name)}</div>
                )}
              </Title>
            )}
            <Text style={styles.text_new} id="auth-familysurvey-desc" tabIndex={0} role="article">
              {whitelabelConfig.uiSettings.isFamilySurveyEnabled &&
                portalMicrositeSession.pendingSurveys &&
                portalMicrositeSession?.pendingSurveys.length > 1 ? (
                <strong style={{ fontWeight: 700 }}>
                  {t("AUTH2FA.DESCRIPTION_FAMILYSURVEY")}
                </strong>
              ) : (
                t("AUTHPII.CONTENT")
              )}
            </Text>
          </div>
          {(portalMicrositeSession.landingUrlSnapshot.split("/")[1] === "av" ||
            portalMicrositeSession.landingUrlSnapshot.split("/")[1] === "ar" ||
            portalAuthSession.user_name) &&
            !hasActiveMember &&
            (whitelabelConfig.uiSettings.isFamilySurveyEnabled ||
              !whitelabelConfig.uiSettings.isFamilySurveyEnabled) && (
              <div style={styles.subheader}>
                <div style={styles.subheaderinner}>
                  <Text style={styles.text} id="dob-text" tabIndex={0} role="article">
                    {t("AUTHPII.DOBTEXT")}
                    {portalAuthSession.user_name === "" ? (
                      <>
                        {hashText(
                          portalMicrositeSession.pendingSurveys[0].MemberName
                        )}
                      </>
                    ) : (
                      <>{hashText(portalAuthSession.user_name)}</>
                    )}
                  </Text>
                </div>
              </div>
            )}

          {filteredSurveys.length > 0 ? (
            <>
              <Title style={styles.texttitle}>
                <Text style={styles.text} id="dob-text-desc" tabIndex={0} role="article">
                  {t("AUTHPII.DOBTEXT")}
                  {hashText(
                    selectedSurvey?.MemberName
                    //portalMicrositeSession.pendingSurveys[0].MemberName
                  )}
                </Text>
              <DateOfBirth
                handleDateChange={handleDateChange}
                dob={dob}
                language={uiState.Language}
                style={{ fontWeight: "bold" }}
              />
              </Title>
            </>
          ) : (
            // <PendingSurveyList
            //   surveyList={filteredSurveys}
            //   onSelectSurvey={handleChangeSurvey}
            // />
            (whitelabelConfig.uiSettings.isFamilySurveyEnabled ||
              !whitelabelConfig.uiSettings.isFamilySurveyEnabled) &&
            portalMicrositeSession.pendingSurveys &&
            portalMicrositeSession?.pendingSurveys.length > 0 &&
            /^\/s\//.test(portalMicrositeSession.landingUrlSnapshot) &&
            (portalMicrositeSession.pendingSurveys.length > 1 ? (
              <div style={styles.headercontainer}>
              <PendingSurveyList
                surveyList={portalMicrositeSession.pendingSurveys}
                onSelectSurvey={(surveyMeta: any) => {
                  handleChangeSurvey(surveyMeta);
                }}
              />
              </div>
            ) : (
                <Title style={styles.texttitle}>
                  {/* {t("AUTHPII.TITLE")}
                  <div>{portalMicrositeSession.pendingSurveys[0].MemberName}</div> */}
                  <div style={styles.subheaderinner}>
                    <Text style={styles.text} id="dob-text-desc2" tabIndex={0} role="article">
                      {t("AUTHPII.DOBTEXT")}

                      {hashText(
                        portalMicrositeSession.pendingSurveys[0].MemberName
                      )}
                    </Text>
                  </div>
                <DateOfBirth
                  handleDateChange={handleDateChange}
                  dob={dob}
                  language={uiState.Language}
                  style={{ fontWeight: "bold" }}
                />
              </Title>
            ))
          )}

          <div style={styles.bodycontainer}>
            <Form
              name="normal_login"
                //  aria-label={t("AUTHPII.TITLE")}
              initialValues={{
                remember: true,
              }}
              role="none"
              layout="vertical"
              requiredMark="optional"
              onFinish={handleFinish}
            >
              {false && (
                <Form.Item
                  style={{ marginBottom: "20px", fontWeight: "bold" }}
                  name="DateOfBirth"
                  rules={[
                    {
                      required: dob.length < 3 ? true : false,
                      message: t("AUTHPII.ENTERDOBERR"),
                    },
                  ]}
                  {...(failedAttempt && {
                    hasFeedback: true,
                    help: validateMsg(),
                    validateStatus: failedAttempt > 1 ? "error" : "error",
                  })}
                >
                  <DateOfBirth
                    handleDateChange={handleDateChange}
                    style={{ fontWeight: "bold" }}
                    dob={dob}
                    language={uiState.Language}
                  />
                </Form.Item>
              )}
              {(!authStep.extras ||
                authStep.extras?.authTypes?.includes("DOB")) &&
                surveyDob && (
                  <Form.Item
                    style={{ marginBottom: "20px", fontWeight: "bold" }}
                    name="DateOfBirth"
                    {...(isDobValid == false && {
                      help: isDobValidationMsg,
                      validateStatus: "error",
                    })}
                  >
                      {whitelabelConfig.uiSettings.isFamilySurveyEnabled &&
                      portalMicrositeSession?.pendingSurveys?.length > 0 ? (
                      <Text style={styles.text} id="familysurvey-desc-2" tabIndex={0} role="article">
                        {t("AUTH2FA.WELCOME_TEXT_FAMILYSURVEY")} {surveyDobUser}
                      </Text>
                    ) : (
                      surveyDobUser ? (
    <Text style={styles.text} id="dob-user" tabIndex={0} role="article">{surveyDobUser}</Text>
  ) : null
                    )}
                    <DateOfBirth
                      handleDateChange={handleDateChange}
                      dob={dob}
                      language={uiState.Language}
                      style={{ fontWeight: "bold" }}
                    />
                  </Form.Item>
                )}
              {authStep.extras &&
                authStep.extras?.authTypes?.includes("ZIP") && (
                  <Form.Item
                    style={{ marginBottom: "20px", fontWeight: "bold" }}
                    name="Zip"
                    {...(isZipValid == false && {
                      help: isZipValidationMsg,
                      validateStatus: "error",
                    })}
                  >
                    <div style={styles.formcontrolblock}>
                      <Text style={styles.formlabel} id="additional-field" tabIndex={0} role="article">
                        {t("AUTHPII.LABEL_ADDITIONAL_FIELD")}
                      </Text>
                      <Text style={styles.formlabel} id="zip-lable" tabIndex={0} role="article">
                        {t("AUTHPII.LABEL_ZIP")}
                      </Text>
                    </div>

                    <InputNumber
                      id="input-number"
                      style={{ width: "100%" }}
                      defaultValue={zip}
                      onChange={(value: any) => {
                        setZip(value);
                      }}
                    />
                  </Form.Item>
                )}
              {authStep.extras &&
                authStep.extras?.authTypes?.includes("SSN_MEDICAID") && (
                  <>
                    <Form.Item
                      style={{ marginBottom: "20px", fontWeight: "bold" }}
                      name="Ssn"
                      {...(isSsnValid == false && {
                        help: isSsnValidationMsg,
                        validateStatus: "error",
                      })}
                    >
                      <div style={styles.formcontrolblock}>
                        <Text style={styles.formlabel} id="additional-field1" tabIndex={0} role="article">
                          {t("AUTHPII.LABEL_ADDITIONAL_FIELD")}
                        </Text>
                        <Text style={styles.formlabel} id="ssn-label" tabIndex={0} role="article">
                          {t("AUTHPII.LABEL_SSN")}
                        </Text>
                      </div>
                      <Input.Password
                        aria-label={t("AUTHPII.LABEL_SSN")}
                        id="ssn-password"
                        style={{ width: "100%" }}
                        onChange={(value: any) => {
                          setSsn(value.target.value);
                        }}
                      />
                    </Form.Item>
                    <Form.Item
                      style={{ marginBottom: "20px", fontWeight: "bold" }}
                      name="Ssn"
                      {...(isSsnValid == false && {
                        help: isMedicaidValidationMsg,
                        validateStatus: "error",
                      })}
                    >
                      <div style={styles.formcontrolblock}>
                        <Text style={styles.formlabel} id="or" tabIndex={0} role="article">OR</Text>
                        <Text style={styles.formlabel} id="medicaid" tabIndex={0} role="article">
                          {t("AUTHPII.LABEL_MEDICAID")}
                        </Text>
                      </div>
                      <Input.Password
                        id="medicaid-password1"
                        aria-label={t("AUTHPII.LABEL_MEDICAID")}
                        style={{ width: "100%" }}
                        onChange={(value: any) => {
                          setMedicaid(value.target.value);
                        }}
                      />
                    </Form.Item>
                  </>
                )}
              {failedAttempt > 0 && (
                <Alert
                  message={validateMsg()}
                  type="error"
                  showIcon
                  style={{
                    marginBottom: "15px",
                    textAlign: isRightAlign ? "right" : "",
                  }}
                />
              )}
              <Form.Item style={{ marginBottom: "0px" }}>
                <Button
                  block={true}
                  type="primary"
                  htmlType="submit"
                  style={styles.button}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  id="verify-details-btn"
                >
                  {t("AUTHPII.FOOTER")}
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
};
export default AuthPage;
